import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';

const Hero: React.FC = () => {
  return (
    <section className="hero min-h-screen bg-base-200">
      <div className="hero-content flex-col lg:flex-row-reverse max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="lg:w-1/2"
        >
          <img
            src="/profile-image.jpg"
            className="max-w-sm rounded-lg shadow-2xl mx-auto object-cover"
            alt="Profile"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.src = 'https://placehold.co/600x400?text=Your+Image';
            }}
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut', delay: 0.2 }}
          className="lg:w-1/2"
        >
          
          <h2 className="text-5xl font-bold mb-4"> Anthonny ANDRIANIRINA</h2>
          <h1 className="text-3xl font-bold mb-4">DevOps Engineer & SOC Analyst</h1>
          <p className="py-6 text-xl">Expert en automatisation, sécurité et gestion d'infrastructure cloud</p>
          <div className="flex gap-4 flex-wrap">
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="#contact"
              className="btn btn-primary"
            >
              Me contacter
            </motion.a>
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="#projects"
              className="btn btn-outline"
            >
              Voir mes projets
            </motion.a>
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="/CV.pdf"
              download
              className="btn btn-secondary gap-2"
            >
              <ArrowDownTrayIcon className="h-5 w-5" />
              Télécharger CV
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
